<template>
  <box-model title="种植规模情况">
    <template v-slot:content>
      <div v-if="!show" class="con no-data-sty">暂无数据</div>
      <div v-else id="line" class="con"></div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { getVarietiesScale } from "@/api/index";
  export default {
    data() {
      return {
        colorSty: {
          0: '#0994FF',
          1: '#38EAFF',
          2: '#06F7A1',
          3: '#FFCC00',
          4: '#FF6637',
          5: '#7458FF'
        },
        show: false
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted() {
      this.getVarietiesScaleFn();
    },
    methods: {
      init(option) {
        const myChart = echarts.init(document.getElementById("line"));
        myChart.setOption(option);
      },
      getVarietiesScaleFn() {
        getVarietiesScale().then((res) => {
          if(!res.data || !res.data?.length){
            this.show = false;
            return;
          };
          this.show = true;
          this.$nextTick(() => {
            const result = res.data;
            let name = [];
            let bData = {};
            // 获取作物名称与年份
            result.forEach((item) => {
              if(!bData[item.year]){
                bData[item.year] = [];
                bData[item.year].push({
                  value: item.area,
                  name: item.varietiesName
                });
              } else {
                bData[item.year].push({
                  value: item.area,
                  name: item.varietiesName
                });
              };
              if(!name.includes(item.varietiesName)){
                name.push(item.varietiesName);
              };
            });
            let copyBDate = JSON.parse(JSON.stringify(bData));
            for(let item in bData){
              let arr1 = bData[item];
              for(let i = 0; i<name.length;i++){
                let state = arr1.some((v) => v?.name === name[i]);
                if(!state){
                  copyBDate[item].push({
                    name: name[i],
                    value: 0
                  });
                }
              }
            };
            let seriesData = [];
            let yName = [];
            name.forEach((item, idx) => {
              let rdata = [];
              for(let v in copyBDate){
                if(!yName.includes(v)){
                  yName.push(v);
                }
                rdata.push(copyBDate[v].find((vi) => vi.name === item).value);
              };
              seriesData.push(this.getSeriesItem(item, idx, rdata));
            });
            const option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                },
                backgroundColor: '#fff',
                formatter: function(params){
                  let item = params[0];
                  let targetStr = []
                  for(let i = 0;i<params.length;i++){
                    let t = `
                      <div style="display: flex;align-items: center;margin-bottom: 8px">
                        <div style="width: 8px;height: 8px;background: ${params[i].color};border-radius: 50%;"></div>
                        <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">${params[i].seriesName}：${params[i].value}亩</div>  
                      </div>
                    `
                    targetStr.push(t);
                  };
                  let result = `
                    <div style="padding: 12px;z-index:1001">
                      <div style="color: #3E3E3E;font-size: 15px;">${item.axisValue}</div>
                      <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                      ${targetStr.join('')}
                    </div>
                  `;
                  return result;
                }
              },
              legend: {
                top: '0',
                data: name,
                itemWidth: 12,
                itemHeight: 6,
                icon: 'rect',
                textStyle: {
                  itemGap: 2, //图例每项之间的间隔
                  color: [],
                  fontStyle: 'normal',
                  fontSize: 14,
                }
              },
              grid: {
                left: '0',
                right: '10%',
                bottom: '0',
                top: '15%',
                containLabel: true
              },
              xAxis: {
                axisLabel: { //调整x轴的lable
                  textStyle: {
                    color: '#fff',
                    fontSize: 15,
                  },
                  formatter: function(value){
                    return +value > 10000 ? parseInt((+value)/10000) + '万+' : value
                  }
                },
                splitLine: {
                  show: false
                }
              },
              yAxis: {
                type: 'category',
                data: yName,
                axisTick : {show: true},
                axisLabel: {
                  textStyle: {
                    color: '#fff',
                    fontSize: 15,
                  }
                },
                splitLine: {
                  show: false
                }
              },
              series: seriesData
            };
            this.init(option);
          });
        })
      },
      getSeriesItem(name, index, data) {
        return {
          name: name,
          type: 'bar',
          stack: '总量',
          color: this.colorSty[index],
          barWidth : 20,
          label: {
            normal: {
              show: false,
              position: 'insideRight'
            }
          },
          data: data
        }
      }
    }
  }
</script>
<style scoped lang="less">
  .con {
    width: 100%;
    height: 260px;
  }
</style>